import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'ag-server-error',
  templateUrl: './server-error.component.html',
  styleUrls: ['./server-error.component.scss'],
  standalone: false,
})
export class ServerErrorComponent {
  constructor(
    private router: Router,
    private location: Location,
  ) {}

  goBack(): void {
    window.location.reload();
    setTimeout(() => {
      this.location.back();
    });
  }
}
